import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
  ValueSansProvider,
} from '@angular/core';
import { AppRoutes } from './router';

export const APP_ROUTER_PATHS = new InjectionToken('APP_ROUTER_PATHS', {
  providedIn: 'root',
  factory: () => ({}),
});

export interface AppRoutesUseValue extends ValueSansProvider {
  useValue: AppRoutes;
}

export interface AppRoutesUseClass extends ClassSansProvider {
  useClass: Type<AppRoutes>;
}

export interface AppRoutesUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => AppRoutes;
}

export type AppRoutesProvider =
  | AppRoutesUseValue
  | AppRoutesUseFactory
  | AppRoutesUseClass;

export type AppRoutesConfig = {
  paths?: AppRoutesUseValue;
};

export function provideAppRouterPaths(config: AppRoutesConfig) {
  return [
    {
      provide: APP_ROUTER_PATHS,
      multi: true,
      ...config.paths,
    },
  ];
}
